var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "notification-trigger"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "#F8FAFC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "bell"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.7001 26.7506C18.8317 26.9786 19.0211 27.168 19.2491 27.2996C19.4771 27.4313 19.7358 27.5006 19.9991 27.5006C20.2624 27.5006 20.521 27.4313 20.7491 27.2996C20.9771 27.168 21.1665 26.9786 21.2981 26.7506M13.446 22.4947C13.348 22.6021 13.2833 22.7357 13.2598 22.8792C13.2364 23.0226 13.2551 23.1698 13.3137 23.3029C13.3724 23.4359 13.4684 23.549 13.5902 23.6284C13.7119 23.7079 13.8541 23.7502 13.9995 23.7503H25.9997C26.1451 23.7504 26.2873 23.7082 26.4091 23.6289C26.5309 23.5496 26.6271 23.4366 26.6859 23.3037C26.7447 23.1708 26.7636 23.0236 26.7403 22.8801C26.717 22.7366 26.6525 22.603 26.5547 22.4955C25.5572 21.4672 24.4997 20.3743 24.4997 16.9998C24.4997 15.8062 24.0256 14.6615 23.1816 13.8175C22.3377 12.9735 21.1931 12.4994 19.9996 12.4994C18.8061 12.4994 17.6615 12.9735 16.8175 13.8175C15.9736 14.6615 15.4995 15.8062 15.4995 16.9998C15.4995 20.3743 14.4412 21.4672 13.446 22.4947Z",
    stroke: "#475569",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse",
    cx: 34,
    cy: 6,
    r: 4,
    fill: "#EF4444"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.f90f7956fc16b64f2d36cb0f968b8d5b.svg";
export { ForwardRef as ReactComponent };